import { defineNuxtPlugin } from "#app";
import 'leaflet/dist/leaflet.css';
import * as L from 'leaflet';
import { LMap, LTileLayer, LMarker } from '@vue-leaflet/vue-leaflet';

export default defineNuxtPlugin((nuxtApp) => {
  if (process.client) {
    // Ensure Leaflet is available globally for vue-leaflet
    window.L = L;
  }

  nuxtApp.vueApp.component('l-map', LMap);
  nuxtApp.vueApp.component('l-tile-layer', LTileLayer);
  nuxtApp.vueApp.component('l-marker', LMarker);
});
